export const MAX_TRANSPORT_ACCESSIBILITY_RATE = 10;
